export function NotFoundPage(): JSX.Element {
  return (
    <main className="min-h-screen p-10">
      <h1 className="font-display text-2xl font-bold text-text">Not found</h1>
    </main>
  );
}
